<template>
  <b-container>
        <b-card title="Stripe Account Connect" >
          <b-card-text class="text-capitalize font-weight-bold">ClarenMenu wants to link your Stripe Account</b-card-text>
          <ul class="list-unstyled">
            <b-media tag="li">
              <h6 class="mt-0 mb-1 text-info">By Access your Stripe Account, you'll <b>ClarenMenu</b> to Read/Write Stripe Details</h6>
              <p class="mb-0 text-danger">
                This will help you to collect direct moeny from customer. we are not pause money behlaf from you.
              </p>
            </b-media>
          </ul>
          <h5 v-if="stripeDetailData && stripeDetailData.id">Account ID ({{ stripeDetailData.id }})</h5>
          <div v-if="isLinked && oAuthMode">
            <p class="text text-success">Successfully Linked Your Account</p>
            <b-button variant="danger" @click="revokeAccount" style="float: right;">Revoke</b-button>
          </div>
  
          <div v-if="!isLinked && oAuthLink && oAuthMode">
            <b-button variant="primary" @click="linkOAuthAccount">OK,I'LL AUTHORIZE IT</b-button>
          </div>

          <p v-if="msgError" class="text-danger">{{msgError}}</p>
        </b-card>
        {{stripeDetailData}}
        <b-button variant="primary" 
                  id="connected-account"
                  v-if="!stripeAccount && !oAuthMode"
                  @click="createStripeAccount">1.Connected Account</b-button>                
        <b-button variant="primary"
                  id="link-account"
                  v-if="stripeAccount && !oAuthMode"
                  @click="linkStripeAccount">2.Link Account</b-button>

        
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  data() {
    return {stripeDetailData:null, oAuthLink:null, msgError : null, oAuthMode:true};
  },
  computed: { 
		...mapState({
      store: 'store',
      selectedLocation : "selectedLocation"
    }),
    stripeAccount() {
      return this.selectedLocation && this.selectedLocation.stripe && this.selectedLocation.stripe.stripeAccount ? this.selectedLocation.stripe.stripeAccount : null
    },
    code(){
      return this.$route.query.code;
    },
    isLinked(){
      return this.stripeDetailData && this.stripeDetailData.requirements && this.stripeDetailData.requirements.disabled_reason === null;
    }
  },
  watch : {
        selectedLocation: {
            deep: true,
            immediate: true,
            handler() {
                this.stripeDetailData = null;
                this.retriveStripeAccount();
            }
        }
  },
  mounted() {
     this.$nextTick(() => {
       this.getLink();
       if(this.code){
          this.oAuthStripeOAuth(this.code)
          this.$router.replace({...this.$router.currentRoute, query: { code: undefined, state: undefined}}) 
       }
     })
  },
  methods: {
    getLink(){
       this.$store
            .dispatch('apiStripeOAuthLink')
            .then(({status, res, error}) => {
                if(status){          
                  this.oAuthLink = res;
                } else {
                  console.log("apiStripeOAuthLink", error) 
                }
            }).catch(e=>{
              console.log("apiStripeOAuthLink", e)                        
            })
    },
    oAuthStripeOAuth(code){
        this.$store
            .dispatch('apiStripeOAuth', { code : code })
            .then(({status, res, error}) => {
                if(status){          
                  this.msgError = null;
                  this.$store.commit('setSelectedLocation', res);
                } else {
                  this.msgError =  error.msgError;
                }
            }).catch(e=>{
              this.msgError = e.msgError;
            })
    },
    revokeAccount(){
      Swal.fire({
                    title: 'Are you sure? it\'s danger',
                    text: "You will not be able to Refund Old Payment!!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Revoke it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$store
                            .dispatch('apiStripeRevoke')
                            .then(({status, error}) => {
                                if(status){          
                                    this.msgError = null;
                                    this.stripeDetailData = null;
                                } else {
                                  this.msgError =  error.msgError;
                                }
                            }).catch(e=>{
                              this.msgError = e.msgError;
                            })
                    }
                })       
    },
    createStripeAccount() {
      this.$store
            .dispatch('apiCreateStripeAccount', {locationId: this.selectedLocation._id})
            .then(({status, res, error}) => {
                if(status){          
                  this.$store.commit('updateStripeAccount', res.id);    
                } else {
                  console.log(error)
                }
            }).catch(e=>{
              console.log("apiStripeCreate-E", e)                        
            })
    },
    retriveStripeAccount() {
      if(!this.stripeAccount) return;
      this.$store
            .dispatch('apiRetriveStripeAccount', {accountId: this.stripeAccount})
            .then(({status, res, error}) => {
                if(status){          
                  this.stripeDetailData = res;
                  if(this.stripeDetailData.requirements && this.stripeDetailData.requirements.disabled_reason) {
                    this.msgError = this.stripeDetailData.requirements.disabled_reason;
                  } else {
                    this.msgError = null;
                  }
                } else {
                  console.log(error);
                }
            }).catch(e=>{
              console.log("apiStripeRetrive-E", e)                        
            })
    },
    linkStripeAccount() {
      if(!this.stripeAccount) return;
      this.$store
            .dispatch('apiLinkStripeAccount', {accountId: this.stripeAccount})
            .then(({status, res, error}) => {
                if(status){
                  if(res.url) {
                    window.location.href = res.url
//                  this.$store.commit('updateStripeAccount', res.id);                        
                  }
                } else {
                  console.log(error)
                }
            }).catch(e=>{
              console.log("apiStripeLink-E", e)                        
            })
    },
    linkOAuthAccount() {
      window.open(this.oAuthLink, "_self")
    }
  }
};
</script>

<style>
</style>